import React, { useEffect } from 'react';
import { SvgIcon } from '../../../ace/pages/calendar/components/svg-icon';

const ShelfItem = ({ item }) => (
    <a href={item.linkUrl} className="digital-gallery-shelf-item" key={item.id}>
        {item.imageUrl &&
         <img src={item.imageUrl} className="digital-gallery-shelf-item-image" alt={item.alt} />
        }
        <div className="digital-gallery-shelf-item-overlay" tabIndex={-1}> </div>
        <div className="digital-gallery-shelf-item-content">
            <h6 className="digital-gallery-shelf-item-title">{item.title}</h6>
            {item.subtitle && (
                <p className="digital-gallery-shelf-item-subtitle">{item.subtitle}</p>
            )}
        </div>
        <div className="digital-gallery-shelf-item-content-hover">
            <div className="digital-gallery-shelf-item-content-hover-inner">
                <p className="h6-style"> Watch </p>
                <SvgIcon iconId="icon-play" cssClass={"svg-icon svg-icon-text"} /> 
            </div>
        </div>
    </a>
);

export default ShelfItem;